import { addScriptAsync } from '|>/shared/dom'
import { logger } from '|>/shared/logger'

/**
 * Chromecast framework, it is required to be included in the page
 */
const CHROMECAST_FRAMEWORK_SCRIPT_URL =
  'https://www.gstatic.com/cv/js/sender/v1/cast_sender.js?loadCastFramework=1'

export const fetch: (
  onFrameworkLoadComplete?: (res: boolean) => void
) => Promise<boolean> = async (onFrameworkLoadComplete) => {
  // If Cast SDK already started loading and set the callback,
  // just wait for it instead of overriding
  if (typeof window.__onGCastApiAvailable === 'function') {
    return new Promise((resolve) => {
      const prevCallback = window.__onGCastApiAvailable
      window.__onGCastApiAvailable = (isAvailable, errorInfo) => {
        prevCallback(isAvailable, errorInfo)

        if (isAvailable) logger.info('Chromecast framework fully loaded')
        else logger.error(`Cast SDK not available: ${errorInfo}`)

        resolve(true)
      }
    })
  }

  // Otherwise, set up the callback before loading
  const frameworkReadyPromise = (
    onFrameworkLoadComplete?: (res: boolean) => void
  ) =>
    new Promise<boolean>((resolve) => {
      window.__onGCastApiAvailable = (isAvailable, errorInfo) => {
        if (isAvailable) logger.info('Chromecast framework fully loaded')
        else logger.error(`Cast SDK not available: ${errorInfo}`)

        onFrameworkLoadComplete?.(isAvailable)
        resolve(true)
      }
    })

  try {
    await addScriptAsync(CHROMECAST_FRAMEWORK_SCRIPT_URL)
    return frameworkReadyPromise(onFrameworkLoadComplete)
  } catch (err) {
    logger.error('Chromecast framework load failed', err)
    return Promise.resolve(true)
  }
}
